document.addEventListener("DOMContentLoaded", () => {
  const popup = document.querySelector(".np-popup");
  const closeBtn = document.querySelector(".np-close");
  const overlay = document.querySelector(".np-overlay");
  const form = document.querySelector("#NoyaNewsletterForm");
  const discountBox = document.querySelector(".np-discount-success");
  const discountCode = document.querySelector(".np-discount-code");
  const copyMessage = document.querySelector(".np-copy-message");

  if (!popup) return;

  const COOKIE_NAME = "np_popup_closed";
  const COUPON_FLAG = "noya_show_coupon";

  function setCookie(name, value, days) {
    const d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${value};expires=${d.toUTCString()};path=/`;
  }

  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
  }

  function openPopup() {
    popup.removeAttribute("hidden");
    document.body.style.overflow = "hidden";
  }

  function closePopup() {
    popup.setAttribute("hidden", true);
    document.body.style.overflow = "";
    setCookie(COOKIE_NAME, "true", 30);
  }

  function showCoupon() {
    openPopup();

    if (form) form.style.display = "none";
    if (discountBox) discountBox.hidden = false;
  }

  if (form) {
    form.addEventListener("submit", () => {
      sessionStorage.setItem(COUPON_FLAG, "true");
    });
  }

  if (sessionStorage.getItem(COUPON_FLAG) === "true") {
    sessionStorage.removeItem(COUPON_FLAG);
    setTimeout(showCoupon, 400);
  } else if (!getCookie(COOKIE_NAME)) {
    setTimeout(openPopup, 3000);
  }

  if (closeBtn) closeBtn.addEventListener("click", closePopup);
  if (overlay) overlay.addEventListener("click", closePopup);

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closePopup();
  });

  if (discountCode) {
    discountCode.addEventListener("click", async () => {
      try {
        await navigator.clipboard.writeText("WL10");
      } catch (e) {}

      if (copyMessage) copyMessage.hidden = false;
    });
  }
});